/** Cebuano (Bisaya), keyed by the English text. Constituent-facing screens first (POS, slips). */
export const CEB: Record<string, string> = {
  'Continue': 'Padayon',
  'Cancel': 'Kanselahon',
  'Save': 'I-save',
  'Back': 'Balik',
  'Yes': 'Oo',
  'No': 'Dili',
  'Close': 'Sirado',
  'Loading…': 'Nag-load…',
  'Retry': 'Usba',
  'Help': 'Tabang',
  'Language': 'Pinulongan',
  'Sign out': 'Pag-sign out',
  // Public card page
  'This is an LGU assistance card. It works only at accredited stores, with the owner\'s PIN.': 'Kini usa ka assistance card sa LGU. Magamit ra kini sa akreditadong tindahan, gamit ang PIN sa tag-iya.',
  'Found this card? Please return it to the LGU office.': 'Nakit-an nimo kini nga card? Palihug iuli sa opisina sa LGU.',
  'Lost card hotline': 'Hotline para sa nawala nga card',
  'Where can I use my card?': 'Asa nako magamit ang akong card?',
};
